<script>
  import Loader from '../components/dark-loader.svelte'
  export let messageData
  export let location
  export let loading
</script>

{#if messageData.type === "start" && !loading}
<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M7.29175 13.125C7.29175 7.48125 11.8563 2.91667 17.5001 2.91667C23.1438 2.91667 27.7084 7.48125 27.7084 13.125C27.7084 20.7813 17.5001 32.0833 17.5001 32.0833C17.5001 32.0833 7.29175 20.7813 7.29175 13.125ZM13.8542 13.125C13.8542 15.1375 15.4876 16.7708 17.5001 16.7708C19.5126 16.7708 21.1459 15.1375 21.1459 13.125C21.1459 11.1125 19.5126 9.47917 17.5001 9.47917C15.4876 9.47917 13.8542 11.1125 13.8542 13.125Z"
    fill="#00B6A4" />
</svg>
<p>Head to start location: <strong>{messageData.location}</strong></p>
<p class="caption"><a href="https://www.google.com/maps/dir/?api=1&destination={messageData.lat},{messageData.lng}">Get Directions</a></p>
{:else if messageData.type === "heading" && !loading}
<svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M7.29175 13.125C7.29175 7.48125 11.8563 2.91667 17.5001 2.91667C23.1438 2.91667 27.7084 7.48125 27.7084 13.125C27.7084 20.7813 17.5001 32.0833 17.5001 32.0833C17.5001 32.0833 7.29175 20.7813 7.29175 13.125ZM13.8542 13.125C13.8542 15.1375 15.4876 16.7708 17.5001 16.7708C19.5126 16.7708 21.1459 15.1375 21.1459 13.125C21.1459 11.1125 19.5126 9.47917 17.5001 9.47917C15.4876 9.47917 13.8542 11.1125 13.8542 13.125Z"
    fill="#00B6A4" />
</svg>
<p>Head to: <strong>{messageData.location}</strong></p>
{:else if messageData.type === "subtitle" && !loading}
<p class="message">{messageData.message}</p>
{:else}
<div class="loader">
  <Loader/>
</div>
{/if}


<style>
  p {
    margin: auto;
    text-align: center;
    //color: #00B6A4;
  }

  strong {
    color: #202020;
  }

  svg {
    width: 100%;
    margin: -2px;
  }

  .caption {
    margin-top: 10px;
  }

  .message {
    display: flex;
  justify-content: center;
  align-items: center;
  }

  .loader {
    width: 100%;
  }
</style>
